// import React from 'react' // 暂时未使用
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import TabsLayout from '@/components/TabsLayout/index'
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop'
import { ProtectedRoute, AuthRoute } from './guards'
import Home from '@/pages/home'
import Login from '@/pages/login'
import Register from '@/pages/register'
import DepositRecords from '@/pages/recharge/deposit-records'
import Account from '@/pages/account'
import My from '@/pages/my'
import SelectCurrency from '@/pages/recharge'
import TransactionHistory from '@/pages/account/transaction-history'
import Card from '@/pages/card'
import KycCertification from '@/pages/kyc-certification'
// import Boot from '@/pages/boot'
import UnableLogin from '@/pages/unable-login'
import CardInfo from '@/pages/card/card-info'
import CurrencyDetails from '@/pages/recharge/currency-details'
import SelectNetwork from '@/pages/recharge/select-network'
import SetPassword from '@/pages/register/set-password'
import VerificationCode from '@/pages/register/verificationcode'
import ApplyPhysicalCard from '@/pages/card/physical-card/apply-physical-card'
import ApplyCard from '@/pages/card/apply-card'
import AddShippingAddress from '@/pages/card/physical-card/add-shipping-address'
import ActivateCard from '@/pages/card/physical-card/activate-card'
import SetLimit from './pages/card/set-limit'
import CardHistoryDetail from './pages/card/card-history-detail'
import SetLang from './pages/my/set-lang'
import Safety from './pages/safety'
import BindGoogle from './pages/safety/bind-google'
import BindPhone from './pages/safety/bind-phone'
import BindEmail from './pages/safety/bind-email'
import About from './pages/my/about'
import Help from './pages/my/help'

// 安全中心相关路由
import ChangeAccount from './pages/safety/change-account'
import SelectVerification from './pages/safety/change-account/select-verification'
import VerOldAccountCode from './pages/safety/change-account/ver-old-account-code'
import NewAccount from './pages/safety/change-account/new-account'
import VerNewAccountCode from './pages/safety/change-account/ver-new-account-code'
import ChangeSuccess from './pages/safety/change-account/change-success'
import NewGoogle from './pages/safety/change-account/new-google'

// 忘记密码相关路由
import ForgotPassword from './pages/unable-login/forgot-password'
import EnterAccount from './pages/unable-login/forgot-password/enter-account'
import VerAccountCode from './pages/unable-login/forgot-password/ver-account-code'
import ResetPassword from './pages/unable-login/forgot-password/reset-passwod'

// 汇款相关路由
import Remittance from './pages/remittance'
import PayeeList from './pages/remittance/payee-list'
import AddPayee from './pages/remittance/add-payee'
import RemittanceRecord from './pages/remittance/record'

// 兑换相关路由
import Exchange from './pages/exchange'
import ExchangeConfirm from './pages/exchange/confirm'
import ExchangeRecord from './pages/exchange/record'


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Auth Routes (without tabs) - 不需要登录的页面 */}
        {/* <Route path="/boot" element={<Boot />} /> */}
        <Route path="/login" element={
          <AuthRoute>
            <Login />
          </AuthRoute>
        } />
        {/* 注册相关路由 */}
        <Route path="/register" element={
          <AuthRoute>
            <Register />
          </AuthRoute>
        } />
        <Route path="/register/verification-code" element={
          <AuthRoute>
            <VerificationCode />
          </AuthRoute>
        } />
        <Route path="/register/set-password" element={
          <AuthRoute>
            <SetPassword />
          </AuthRoute>
        } />

        {/* 无法登录相关路由 */}
        <Route path="/unable-login" element={<UnableLogin />} />
        {/* 忘记密码相关路由 */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password/enter-account" element={<EnterAccount />} />
        <Route path="/forgot-password/ver-account-code" element={<VerAccountCode />} />
        <Route path="/forgot-password/reset-password" element={<ResetPassword />} />


        {/* Main App Routes (with tabs) - 需要登录的页面 */}
        <Route path="/" element={
          <ProtectedRoute>
            <TabsLayout />
          </ProtectedRoute>
        }>
          <Route path="home" element={<Home />} />
          <Route path="account" element={<Account />} />
          <Route path="card" element={<Card />} />
          <Route path="my" element={<My />} />
          <Route index element={<Navigate to="/home" replace />} />
        </Route>

        {/* Other Routes (without tabs) - 需要登录的页面 */}
        {/* 统一的申请卡片页面（虚拟卡和实体卡共用） */}
        <Route path="/card/apply-card" element={
          <ProtectedRoute>
            <ApplyCard />
          </ProtectedRoute>
        } />
        {/* 实体卡申请页面 */}
        <Route path="/card/apply-physical-card" element={
          <ProtectedRoute>
            <ApplyPhysicalCard />
          </ProtectedRoute>
        } />
        {/* 添加邮寄地址页面 */}
        <Route path="/card/add-shipping-address" element={
          <ProtectedRoute>
            <AddShippingAddress />
          </ProtectedRoute>
        } />
        <Route path="/card/activate-card" element={
          <ProtectedRoute>
            <ActivateCard />
          </ProtectedRoute>
        } />
        <Route path="/card/card-info" element={
          <ProtectedRoute>
            <CardInfo />
          </ProtectedRoute>
        } />
        <Route path="/card/set-limit" element={
          <ProtectedRoute>
            <SetLimit />
          </ProtectedRoute>
        } />
        <Route path="/card/card-history-detail" element={
          <ProtectedRoute>
            <CardHistoryDetail />
          </ProtectedRoute>
        } />
        {/* 存款页面 */}
        <Route path="/recharge/select-currency" element={
          <ProtectedRoute>
            <SelectCurrency />
          </ProtectedRoute>
        } />
        <Route path="/recharge/deposit-records" element={
          <ProtectedRoute>
            <DepositRecords />
          </ProtectedRoute>
        } />
        <Route path="/recharge/currency-details" element={
          <ProtectedRoute>
            <CurrencyDetails />
          </ProtectedRoute>
        } />
        <Route path="/recharge/select-network" element={
          <ProtectedRoute>
            <SelectNetwork />
          </ProtectedRoute>
        } />
        {/* 汇款页面 */}
        <Route path="/remittance/transfer" element={
          <ProtectedRoute>
            <Remittance />
          </ProtectedRoute>
        } />
        <Route path="/remittance/payee-list" element={
          <ProtectedRoute>
            <PayeeList />
          </ProtectedRoute>
        } />
        <Route path="/remittance/add-payee" element={
          <ProtectedRoute>
            <AddPayee />
          </ProtectedRoute>
        } />
        <Route path="/remittance/record" element={
          <ProtectedRoute>
            <RemittanceRecord />
          </ProtectedRoute>
        } />
        {/* 兑换页面 */}
        <Route path="/exchange/transfer" element={
          <ProtectedRoute>
            <Exchange />
          </ProtectedRoute>
        } />
        <Route path="/exchange/confirm" element={
          <ProtectedRoute>
            <ExchangeConfirm />
          </ProtectedRoute>
        } />
        <Route path="/exchange/record" element={
          <ProtectedRoute>
            <ExchangeRecord />
          </ProtectedRoute>
        } />
        {/* 账户页面 */}
        <Route path="/account/transaction-history" element={
          <ProtectedRoute>
            <TransactionHistory />
          </ProtectedRoute>
        } />
        <Route path="/kyc-certification" element={<KycCertification />} />


        {/* <Route path="/select-account-type" element={<SelectAccountType />} /> */}

        <Route path="/my/set-lang" element={
          <ProtectedRoute>
            <SetLang />
          </ProtectedRoute>
        } />
        <Route path="/my/about" element={
          <ProtectedRoute>
            <About />
          </ProtectedRoute>
        } />
        <Route path="/my/help" element={
          <ProtectedRoute>
            <Help />
          </ProtectedRoute>
        } />

        <Route path="/safety" element={
          <ProtectedRoute>
            <Safety />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-google" element={
          <ProtectedRoute>
            <BindGoogle />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-phone" element={
          <ProtectedRoute>
            <BindPhone />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-email" element={
          <ProtectedRoute>
            <BindEmail />
          </ProtectedRoute>
        } />
        <Route path="/safety/change-account" element={
          <ProtectedRoute>
            <ChangeAccount />
          </ProtectedRoute>
        } />
        <Route path="/change-account/select-verification" element={
          <ProtectedRoute>
            <SelectVerification />
          </ProtectedRoute>
        } />
        <Route path="/change-account/ver-old-account-code" element={
          <ProtectedRoute>
            <VerOldAccountCode />
          </ProtectedRoute>
        } />
        <Route path="/change-account/new-account" element={
          <ProtectedRoute>
            <NewAccount />
          </ProtectedRoute>
        } />
        <Route path="/change-account/ver-new-account-code" element={
          <ProtectedRoute>
            <VerNewAccountCode />
          </ProtectedRoute>
        } />
        <Route path="/change-account/change-success" element={
          <ProtectedRoute>
            <ChangeSuccess />
          </ProtectedRoute>
        } />

        <Route path="/change-account/new-google" element={
          <ProtectedRoute>
            <NewGoogle />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  )
}

export default App